<main aria-label="Resource Center">
  @if (showFolders) {
    <section class="resource-center">
      <div class="container" data-test-id="resourceCenterTableContainer">
        <section class="resource-center__table">
          <zip-table
            data-test-id="resourceCenterTable"
            [data]="config?.folders?.data"
            [options]="config.folders"
            (cellClicked)="displayFolderContents($event)"
          >
          </zip-table>
        </section>
      </div>
    </section>
  } @else {
    <section class="documents-list">
      @if (!config?.showOnlyDocuments) {
        <div class="container">
          <div
            data-test-id="resourceCenterDocumentBackButton"
            class="documents-list__back t-link t-bold"
            (click)="toggleDisplay()"
          >
            < {{ config?.documents?.backTitle || 'Back to Resource Center' }}
          </div>
        </div>
      }
      <div class="container">
        <section class="documents-list__table">
          <zip-table
            data-test-id="resourceCenterDocumentTable"
            [data]="documentsConfig?.data"
            [options]="documentsConfig"
            (cellClicked)="getDocument($event)"
          >
          </zip-table>
        </section>
      </div>
    </section>
  }
</main>

@if (config?.showFooter && !footerConfig?.usesDesignSystem) {
  <zip-footer data-test-id="resourceCenterFooter"></zip-footer>
}
